import { getSelectors } from '@repo/core'
import { selectorsConfig } from './selectors.const'

export const accountListDataSelector = getSelectors({
  getRootPath: selectorsConfig.accountListDataSelector.getRootPath,
})
